import { ImpressionSource } from 'src/app/@utils/gtm-tracking/events';
import { mapToTrackableProduct } from 'src/app/@utils/gtm-tracking/utils/mapToTrackableProduct';

import { ProductSearchViewModel } from '@models/api-search.models';

import { Product } from '../model';

export type ProductClickEvent = {
    event: 'select_item';
    item_list_id?: string;
    item_list_name?: string;
    ecommerce: {
        items: Product[];
    };
};

export const trackProductClickEvent = (
    product: ProductSearchViewModel,
    impressionSource?: ImpressionSource
): ProductClickEvent => ({
    event: 'select_item',
    item_list_name: impressionSource,
    ecommerce: {
        items: [mapToTrackableProduct({ ...product, ...(impressionSource ? { list: impressionSource } : {}) })]
    }
});
